@if (educationalPath$ | async; as path) {
<div class="educational-path-card">
  <div class="card-header">
    <h2 class="path-name">{{ path.name || "-" }}</h2>
    <p class="path-full-name">{{ path.full_name || "-" }}</p>
  </div>
  <div class="card-content">
    <!-- Path Information Section -->
    <div class="section-divider">
      <h3 class="section-title">Uddannelsesvej Information</h3>
    </div>
    <div class="info-section">
      <div class="info-item">
        <span class="label">Antal versioner</span>
        <span class="value">{{
          path.versions.length ? path.versions.length : "-"
        }}</span>
      </div>
      @if (path.created_at) {
      <div class="info-item">
        <span class="label">Oprettet</span>
        <span class="value">{{ path.created_at | date : "dd/MM/yyyy" }}</span>
      </div>
      }
    </div>
    <!-- Version Information Section - Only show when a version is selected -->
    @if (hasSelectedVersion() && getVersionId(path)) {
    <div>
      <div class="section-divider">
        <h3 class="section-title">Version Information</h3>
      </div>
      <div class="version-details">
        @if (getVersionId(path)) {
        <div class="version-badge">{{ getVersionName(path) }}</div>
        } @if (getVersionCreatedAt(path)) {
        <div class="version-date">
          Oprettet: {{ getVersionCreatedAt(path) | date : "dd/MM/yyyy" }}
        </div>
        }
      </div>
      <div class="info-section">
        <div class="info-item">
          <span class="label">Vedligeholdelsesinterval</span>
          <span class="value">{{ getMaintenanceIntervalText(path) }}</span>
        </div>
        @if (getRecurrenceTypeText(path)) {
        <div class="info-item">
          <span class="label">Gentagelses type</span>
          <span class="value">{{ getRecurrenceTypeText(path) }}</span>
        </div>
        }
        @if (getCalendarAnchorDateText(path)) {
        <div class="info-item">
          <span class="label">Rul startdato</span>
          <span class="value">{{ getCalendarAnchorDateText(path) }}</span>
        </div>
        }
        <div class="info-item">
          <span class="label">Påkrævet vedligeholdelsestid</span>
          <span class="value">{{
            formatMinutesToHours(getMaintenanceMinutesRequired(path))
          }}</span>
        </div>
      </div>
      <!-- Current Maintenance Period Section -->
      @if (getCurrentMaintenancePeriod(path).start &&
      getCurrentMaintenancePeriod(path).end) {
      <div class="maintenance-period-section">
        <div class="section-divider">
          <h3 class="section-title">Nuværende vedligeholdelsesrul</h3>
        </div>
        <div class="period-dates">
          <span class="label">Periode:</span>
          <span class="value"
            >{{
              getCurrentMaintenancePeriod(path).start | date : "dd/MM/yyyy"
            }}
            -
            {{
              getCurrentMaintenancePeriod(path).end | date : "dd/MM/yyyy"
            }}</span
          >
        </div>
        @if (getRollYearsLabel(path)) {
        <div class="period-dates">
          <span class="label">År i rul:</span>
          <span class="value">{{ getRollYearsLabel(path) }}</span>
        </div>
        }
        @if (getRemainingDaysInMaintenancePeriod(path)) {
        <div class="remaining-days">
          <span class="label">Tid tilbage:</span>
          <span class="value"
            >{{ getRemainingDaysInMaintenancePeriod(path) }} dage</span
          >
        </div>
        }
      </div>
      }
    </div>
    }
    <!-- No version selected message -->
    @if (!hasSelectedVersion()) {
    <div class="no-version-selected">
      <p>Vælg venligst en version for at se yderligere detaljer.</p>
      <p>
        Der skal også vælges en version for at oprette vedligeholdelses- og
        adgangsgivende krav.
      </p>
    </div>
    }
  </div>
</div>
}
